import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AddItemsTab } from '@retail/my-assortment/types';
import { UnderlinedTabs } from '@shared/components';
import { useCallback, useMemo } from 'react';
import { TabsProps } from '@mui/material';

interface Props {
  selectedTab: AddItemsTab;
  setSelectedTab: (tab: AddItemsTab) => void;
  includeCentralAssortments: boolean;
  disabled?: boolean;
  sx?: TabsProps['sx'];
}

export const AddItemsTabs = ({
  selectedTab,
  setSelectedTab,
  includeCentralAssortments,
  disabled,
  sx,
}: Props) => {
  const t = useMyAssortmentTFunction();
  const tabs = useMemo(() => {
    const result = [
      { label: t('myAssortment.filters.itemSearch'), value: 'ITEM_SEARCH', disabled },
      { label: t('myAssortment.actions.importItems'), value: 'IMPORT', disabled },
    ];
    if (includeCentralAssortments) {
      result.push({
        label: t('myAssortment.actions.centralAssortments'),
        value: 'CENTRAL_ASSORTMENTS',
        disabled,
      });
    }
    return result;
  }, [disabled, includeCentralAssortments, t]);

  const selectTab = useCallback(
    (_: any, newTab: AddItemsTab) => setSelectedTab(newTab),
    [setSelectedTab]
  );

  return (
    <UnderlinedTabs id="draft" tabs={tabs} currentTab={selectedTab} onChange={selectTab} sx={sx} />
  );
};
